(function () {
  'use strict';

  var SESSION_KEY = 'studio_shop_popup_shown';
  var COOKIE_NAME = 'studio_shop_popup_shown';

  function setSessionCookie() {
    try { document.cookie = COOKIE_NAME + '=1; path=/'; } catch (e) {}
  }
  function markShown() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    setSessionCookie();
  }
  function hasSession() {
    try { if (sessionStorage.getItem(SESSION_KEY) === '1') return true; } catch (e) {}
    try { return document.cookie.split('; ').some(function (c) { return c.split('=')[0] === COOKIE_NAME; }); } catch (e) {}
    return false;
  }
  function hideWithFade(el, cb) {
    if (!el) { if (cb) cb(); return; }
    el.style.opacity = '0';
    setTimeout(function () {
      el.style.display = 'none';
      if (cb) cb();
    }, 300);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('popup-studio-shop');
    if (!popup) return;
    var closeBtn = document.getElementById('popup-close-btn');

    if (!hasSession()) {
      popup.style.display = 'flex';
      window.getComputedStyle(popup).opacity;
      popup.style.opacity = '1';
      popup.style.transition = 'opacity 0.3s ease';
      markShown();
      popup.setAttribute('aria-hidden', 'false');
    } else {
      popup.style.display = 'none';
      popup.setAttribute('aria-hidden', 'true');
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        try { markShown(); } catch (e) {}
        hideWithFade(popup, function () {
          window.location.href = '/';
        });
      });
    }

    // Attach click handlers to halves — fallback to "/" if no link present
    var halves = popup.querySelectorAll('.popup-half');
    Array.prototype.forEach.call(halves, function (half) {
      var target = (half.getAttribute('data-target-link') || half.getAttribute('data-link') || half.getAttribute('data-href') || '').trim();
      if (!target) target = '/';
      half.addEventListener('click', function (evt) {
        try { markShown(); } catch (e) {}
        // small delay ensures storage/cookie set
        setTimeout(function () {
          window.location.href = target;
        }, 10);
      });
    });

    // Close on Escape for quick testing/accessibility
    document.addEventListener('keydown', function (evt) {
      if (!popup || popup.style.display === 'none') return;
      if (evt.key === 'Escape' || evt.key === 'Esc') {
        if (closeBtn) closeBtn.click();
      }
    });
  });
})();